import {Component, provide} from "@angular/core";
import {NgLocalization} from "@angular/common";

class MessagesLocalization extends NgLocalization {
  getPluralCategory(value: any): string {
    if (typeof value === "number") {
      if (value < 5) {
        return "few";
      }
    }
    return value;
  }
}

@Component({
  selector: "common-i18nplural",
  template: `
  <usecase-container title="I18nPlural" src="common/i18nplural">
    <usecase-content>
      <div [ngPlural]="count">
        <template ngPluralCase="=0"><p>Zero</p></template>
        <template ngPluralCase="=1"><p>One</p></template>
        <template ngPluralCase="few"><p>Few</p></template>
        <template ngPluralCase="other"><p>Large</p></template>
      </div>
      <p>Count: {{count}}</p>
      <button (click)="countUp();">Count Up</button>
      <button (click)="reset()">Reset</button>
    </usecase-content>
  </usecase-container>
    `,
  providers: [provide(NgLocalization, { useClass: MessagesLocalization })]
})
export class I18nPluralComponent {
  private count = 0;

  countUp() {
    this.count++;
  }

  reset() {
    this.count = 0;
  }
}



/** WEBPACK FOOTER **
 ** ./script/common/i18nplural/component.ts
 **/